import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

interface CMSDataContextType {
  globalData: any;
  isLoading: boolean;
  refreshData: () => Promise<void>;
}

const CMSDataContext = createContext<CMSDataContextType | undefined>(undefined);

export const CMSDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [globalData, setGlobalData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  const loadData = async () => {
    try {
      const { data, error } = await supabase
        .from('cms_global')
        .select('locales')
        .eq('draft', false)
        .single();
      
      if (error) {
        console.log('No published global content found');
        setGlobalData(null);
      } else {
        setGlobalData(data);
      }
    } catch (error) {
      console.log('Failed to load CMS data');
      setGlobalData(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const refreshData = async () => {
    setIsLoading(true);
    await loadData();
  };

  return (
    <CMSDataContext.Provider value={{ globalData, isLoading, refreshData }}>
      {children}
    </CMSDataContext.Provider>
  );
};

export const useCMSData = () => {
  const context = useContext(CMSDataContext);
  if (context === undefined) {
    throw new Error('useCMSData must be used within a CMSDataProvider');
  }
  return context;
};
